export const Feedback = {
  getEditionFeedback: {
    url: "/feedback/edition",
    method: ["GET"],
    required: ["editionId"]
  },
  createEditionFeedback: {
    url: "/feedback/edition?formId={formId}",
    method: ["POST"]
  },
  getEditionFeedbackForm: {
    url: "/feedback/edition/form",
    method: ["GET"],
    required: ["formId"]
  },
  getProductFeedback: {
    url: "/feedback/product",
    method: ["GET"],
    required: ["productId"]
  },
  createProductFeedback: {
    url: "/feedback/product?productId={productId}",
    method: ["POST"]
  },
  listEditionProducts: {
    url: "/feedback/subscriber/product",
    method: ["GET"],
    required: ["subscriberId", "editionId"]
  }
};
